import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Link from 'gatsby-link'

class BlogNav extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isMobile: false,
      navToggle: 'nav-hidden'
    }

    this.blogNavDrop = this.blogNavDrop.bind(this)
  }

  blogNavDrop () {
    const nav = this.state.navToggle === 'nav-hidden' ? 'nav-show' : 'nav-hidden'
    this.setState({
      navToggle: nav
    })
  }

  render () {
    let categoryList = []
    let categoryFilter = this.props.categorySlug || 'All'

    if (this.props.drupalCategory) {
      categoryList = this.props.drupalCategory.map((cat, ind) => {
        const category = cat.node.title.toLowerCase()
        const highlightCat = categoryFilter === cat.node.title ? 'highlight' : ''

        return (
          <div className={`blog--category ${highlightCat}`} key={ind}>
            <Link to={`/updates/category/${category}`}>
              {cat.node.title}
            </Link>
          </div>
        )
      })
    }

    const allHighlight = categoryFilter === 'All' ? 'highlight' : ''

    const allItem = (
      <div className={`blog--category ${allHighlight}`} key={200}>
        <Link to={`/updates`}>
          All
        </Link>
      </div>
    )

    const blogNav = [allItem, ...categoryList]

    return (
      <div className='blog--nav'>
        <div className='blog--current-cat'
          onClick={this.blogNavDrop}>
          {this.props.categoryFilter}
          <span className='fas fa-angle-down' />
        </div>
        <h3>Filter by category</h3>
        <div className={`blog--navlist ${this.state.navToggle}`}>
          {blogNav}
        </div>
      </div>
    )
  }
}

BlogNav.propTypes = {
  categoryFilter: PropTypes.string,
  categorySlug: PropTypes.string,
  drupalCategory: PropTypes.array
}

export default BlogNav



// WEBPACK FOOTER //
// ./src/components/blog-nav.js